var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"fixed"},[(_vm.clubLogo)?_c('h2',{staticClass:"club"},[_c('div',{staticClass:"item",style:(("background-image: url(" + _vm.clubLogo + ");"))},[_vm._v("\n        "+_vm._s(_vm.$t('footer.clubLogo'))+"\n      ")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f8e8d3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Footer.vue
// module id = null
// module chunks = 